import(/* webpackMode: "eager" */ "/vercel/path0/app/not-found.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
